import * as React from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { GlobalStateContext } from "../general/GlobalState";
import { MailingContactsContext } from "../mailing/contacts/MailingContactsContext";
import { ReleaseStateContext } from "../releases/ReleaseState";
import { getMailingGroupItems } from "../../services/MailingSVC";
import { getMailingGroupItemsGeneral } from "../../services/MailingGeneralSVC";
import { DropDownTreeComponent, MultiSelectComponent, CheckBoxSelection, Inject } from "@syncfusion/ej2-react-dropdowns";
import '../mailing/contacts/contacts.css';

export const GroupsBox = (props) => {
    let multiSelectGroups;
    const [globalState] = React.useContext(GlobalStateContext);
    const context = React.useContext(props.type ? ReleaseStateContext : MailingContactsContext);
    const [groups, setGroups] = React.useState(null);
    const [groupsGeneral, setGroupsGeneral] = React.useState(null);
    const { t } = useTranslation();

    React.useEffect(() => {
        let qString = '';
        if (props.type) {
            context.setGroupsSelected([]);
            qString = '?$filter=quantidadeMembros gt 0'
        }
        getMailingGroupItems(globalState.accessToken, qString).then(response => {
            if (response.ok) {
                response.json().then(result => {
                    setGroups(result);
                });
            }
        });

        getMailingGroupItemsGeneral(globalState.accessToken, qString).then(response => {
            if (response.ok) {
                response.json().then(result => {
                    setGroupsGeneral(result);
                });
            }
        });
    }, []);

    React.useEffect(() => {
        if (context.groupsFilter && groups) {
            const groupsFiltered = groups.filter(item => (!context.groupsFilter.idpais || item.idpais === context.groupsFilter.idpais) &&
                (!context.groupsFilter.idregional || item.idregional === context.groupsFilter.idregional));
            multiSelectGroups.dataSource = groupsFiltered;

        }
    }, [context.groupsFilter]);

    const multiSelectChange = e => {
        context.setGroupsSelected(e.value);
    }

    const multiSelectChangeGeneral = e => {
        context.setGeneralGroupsSelected(e.value);
    }

    return (
        <>
            {props.type ? <div className="groupsDiv">
                <label>{t('SendContent:groups')}</label>
                <div className="content d-flex flex-column">
                    {groups &&
                        <MultiSelectComponent
                            id="groups"
                            ref={multiSelect => multiSelectGroups = multiSelect}
                            cssClass="e-filled"
                            dataSource={groups}
                            fields={{ value: "id", text: "nome" }}
                            placeholder={t("Contact:groups_placeholder")}
                            mode="Box"
                            change={multiSelectChange}
                            value={context.groupsSelected}
                        >
                            <Inject services={[CheckBoxSelection]} />
                        </MultiSelectComponent>
                    }
                </div>
            </div> : groups && <MultiSelectComponent
                id="groups"
                ref={multiSelect => multiSelectGroups = multiSelect}
                cssClass="e-filled"
                dataSource={groups}
                fields={{ value: "id", text: "nome" }}
                placeholder={t("Contact:groups_placeholder")}
                mode="Box"
                change={multiSelectChange}
                value={context.groupsSelected}
            >
                <Inject services={[CheckBoxSelection]} />
            </MultiSelectComponent>}

            {props.type && <div className="groupsDiv">
                <label>{t('SendContent:groups_general')}</label>
                <div className="content d-flex flex-column">
                    {groupsGeneral &&
                        <MultiSelectComponent
                            id="groupsGeneral"
                            cssClass="e-filled"
                            dataSource={groupsGeneral}
                            fields={{ value: "id", text: "nome" }}
                            placeholder={t("Contact:groups_placeholder")}
                            mode="Box"
                            change={multiSelectChangeGeneral}
                            value={context.generalGroupsSelected}
                        >
                            <Inject services={[CheckBoxSelection]} />
                        </MultiSelectComponent>
                    }
                </div>
            </div>}
        </>

    )
}